import { useTheme } from '@material-ui/core';
import { useEffect } from 'react';

// Keeps CSS variables in sync with current MUI theme so they can be used outside react context

function ThemeVariablesSync() {
  const theme = useTheme();

  useEffect(() => {
    document.body.style.setProperty(
      '--mui-bg',
      theme.palette.background.paper
    );
    document.body.style.setProperty(
      '--mui-text-primary',
      theme.palette.text.primary
    );
    document.body.style.setProperty(
      '--mui-text-secondary',
      theme.palette.text.secondary
    );
    document.body.style.setProperty(
      '--mui-shadow',
      theme.shadows[24]
    );
  }, [theme]);

  return null;
}

export default ThemeVariablesSync;
